import "./GatewayList.css";

import GatewayCard from "../GatewayCard/GatewayCard";
import GatewaySkeleton from "../GatewaySkeleton/GatewaySkeleton";

export default function GatewayList({

    gateways,

    selectedGateway,

    onSelect,

    loading,

}) {

    if (loading) {

        return (

            <div className="gateway-loading">

                <>
                    <GatewaySkeleton />
                    <GatewaySkeleton />
                    <GatewaySkeleton />
                </>

            </div>

        );

    }

    return (

        <section className="gateway-list">

            {

                gateways.map(gateway => (

                    <GatewayCard

                        key={gateway.id}

                        gateway={gateway}

                        selected={

                            selectedGateway?.id === gateway.id

                        }

                        onSelect={onSelect}

                    />

                ))

            }

        </section>

    );

}